import Slider from "react-slick";
import styled from "styled-components";

export const Container = styled.div`
  background: ${(props) => `url(${props.backgroundImage})`};
  background-color: ${(props) => props?.backgroundColor ?? "white"};
  background-repeat: no-repeat;
  background-position: left bottom;
  padding-top: ${(props) => props?.paddingTop ?? "72px"};
`;

export const SliderGlobal = styled(Slider)`
  &.slick-track {
    display: flex;
  }
  &.slick-slider {
    height: 100%;
  }
  &.slider div {
    height: 100% !important; /* added this */
  }
  &.slick-track .slick-slide {
    display: flex;
    height: auto;
  }
`;

export const ImgScroll = styled.img`
  position: absolute;
  // right: -40px;
  // bottom: -20px;
  z-index: 3;
  width: 105px;
  @media screen and (min-width: 769px) {
    transform: none;
    bottom: 0;
    right: 8vw;
    cursor: pointer;
  }
  transform: translate(70vw, 390px);
`;
